<div class="wrapper vertical-widget widget-apostas" ref:widget>
  { #if game }
    <div class="logo-wrapper">
      <a href="https://apostas.sapo.pt" target="_blank">
        <img
          alt="Logo Sapo Apostas"
          src="https://imgs.sapo.pt/sapologos/current/d7739c2fd3de7f9d585bcf3f3ad7343d05a9276dd3f60977abecb7a889d0ef44.png"
          srcset="https://imgs.sapo.pt/sapologos/current/d7739c2fd3de7f9d585bcf3f3ad7343d05a9276dd3f60977abecb7a889d0ef44.png 1x, https://imgs.sapo.pt/sapologos/current/80996461119b400bd2866824b8a57425b07cf04ae7356943de739d2ec8540272.png 2x"
        />
      </a>
    </div>
    <div class="claim-wrapper">
      <h6>As melhores odds<br>para este jogo</h6>
    </div>
    <div class="ink-grid odds-wrapper column-group">
      <div class="all-60 large-60 medium-80 small-100 tiny-100  push-center">
        { #each Object.entries(game.odds) as [ key, odds ] }
          <a href={ game.url } target="_blank">
            <OddsBlock
              odds={ game.odds[key] }
              providers={ providers }
              classes="odds-block--tall"
            >
              <span>{ markets[key] } { game.odds[key].title || '' }</span>
            </OddsBlock>
          </a>
        { /each }
      </div>
      <div class="all-100  btn-wrapper">
        <a href={ game.url } target="_blank" class="cta-btn">Ver todas as apostas</a>
      </div>
    </div>
  { /if }
  <div style="margin-top: -15px;height: 40px; display:table; width:100%; text-align:center; line-height:.9em; padding: 0 1em; background-color: #1a1a1a;">
    <small style="color: #fff; vertical-align: middle; display: table-cell;">O jogo é proibido a menores de 18 anos. Aposte de forma responsável.</small>
  </div>
</div>

<script>
  import { load as loadGame } from './../services/game';
  import { load as loadProviders } from './../services/provider';

  import getParams from './../util/get-params';

  import OddsBlock from './odds-block.html';
  
  export default {
    data() {
      return {
        game: null,
        providers: [],
        markets: {
          'tr_1x2': '1 x 2 Tr',
          'int_1x2': '1 x 2 Int',
          'dv_1x2': '1 x 2 Dv'
        },
        onload: null
      };
    },
    methods: {
      async loadGame(id) {
        const game = await loadGame(id, { markets: ['tr_1x2', 'int_1x2', 'dv_1x2'] });
        this.set({ game });
      },
      async loadProviders() {
        const providers = await loadProviders();
        this.set({ providers });
      },
      async fetchData() {
        const { gameId } = this.get();
        try {
          this.loadGame(gameId);
          this.loadProviders();
        } catch (error) {
          console.log(error);
        }
      },
      loadSponsor() {
        if (
          window &&
          window.SAPO &&
          window.SAPO.CPU &&
          window.SAPO.CPU.refresh
        ) window.SAPO.CPU.refresh('#widget-apostas .logo_sponsor');
      }
    },
    async oncreate () {
      if (window && window.location) {
        const { href } = window.location;
        const params = getParams(href);
        if (params.game_id) this.set({ gameId: params.game_id });
      }
      await Promise.all([ this.fetchData(), this.loadSponsor() ]);
      this.on('update', () => {
        this.fire('load', this.refs.widget);
      });
    },
    components: {
      OddsBlock
    }
  }
</script>

<style type="text/scss">
  @import './style/utilities.scss';

  .wrapper {
    background-color: color(scale, 10%);
    overflow: hidden;
  }

  .ink-grid {
    @include mobile{
      padding: 0;
    }
  }

  .vertical-widget {
    .logo-wrapper {
      background-color: color(scale);
      padding: 16px 0;
      text-align: center;
      img {
        max-height: 24px;
      }
    }
    
    .claim-wrapper {
      background: url('./images/hero-background.png') no-repeat center center;
      background-size: cover;
      padding: 32px 0 80px 0;
      text-align: center;
      h6 {
        font-size: 18px;
        font-weight: 400;
        color: white;
        text-transform: uppercase;
        margin: 0;
        letter-spacing: 1px;
      }
    }

    .odds-wrapper {
      margin-top: -48px;
    }

    .btn-wrapper {
      display: flex;
    }

    .cta-btn {
      display: block;
      margin: 4px auto 24px auto;
      padding: 14px 28px;
      background-color: color(main);
      font-size: 16px;
      font-weight: 300;
      color: white;
      white-space: nowrap;
      &:hover {
        background-color: color(main, 10%, dark);
      }
    }
  }
</style>
